import styled, { css } from 'styled-components';
export const ConversationItemContent = styled.div `
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const ConversationItemActions = styled.div `
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const ConversationContextBadges = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;
`;
export const ConversationContextBadge = styled.div `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;
  max-width: 100%;
  padding: ${({ theme }) => `${theme.spacing.xs}px ${theme.spacing.sm}px`};
  border-radius: ${({ theme }) => theme.border_radius.full};
  border: 1px solid
    ${({ theme, $variant }) => $variant === 'application'
    ? theme.colors.orange_3
    : $variant === 'profile'
        ? theme.colors.green_dark
        : theme.colors.purple_3};
  background: ${({ theme, $variant }) => $variant === 'application'
    ? theme.colors.orange_4
    : $variant === 'profile'
        ? theme.colors.green_4
        : theme.colors.purple_5};
  ${({ theme, $variant }) => $variant === 'profile' &&
    css `
      border-radius: ${theme.border_radius.card};
    `}

  > :first-child {
    flex-shrink: 0;
  }
`;
export const ConversationContextLabel = styled.span `
  color: ${({ theme }) => theme.colors.grey_2};
  font-size: ${({ theme }) => theme.fonts.overline};
  letter-spacing: ${({ theme }) => theme.letterSpacing.overline}px;
  line-height: ${({ theme }) => theme.fontsLineHeights.overline};
`;
export const ConversationContextValue = styled.span `
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme, $variant }) => $variant === 'application'
    ? theme.colors.orange_1
    : $variant === 'profile'
        ? theme.colors.green_dark
        : theme.colors.purple_1};
  font-size: ${({ theme, $variant }) => $variant === 'profile' ? theme.fonts.overline : theme.fonts.caption};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.caption}px;
  line-height: ${({ theme, $variant }) => $variant === 'profile'
    ? theme.fontsLineHeights.overline
    : theme.fontsLineHeights.caption};
`;
export const ConversationProcessingBadge = styled.span `
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-width: 0;
  max-width: 100%;
  padding: ${({ theme }) => `${theme.spacing.xs}px ${theme.spacing.sm}px`};
  border-radius: ${({ theme }) => theme.border_radius.full};
  background: ${({ theme }) => theme.colors.green_4};
  border: 1px solid ${({ theme }) => theme.colors.green_3};
  color: ${({ theme }) => theme.colors.green_status};
  font-size: ${({ theme }) => theme.fonts.overline};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.overline}px;
  line-height: ${({ theme }) => theme.fontsLineHeights.overline};
  white-space: nowrap;
`;
const ActiveStyle = css `
  background: ${({ theme }) => theme.colors.beige_4};
  border-color: ${({ theme }) => theme.colors.grey_4};
  border-left-color: ${({ theme }) => theme.colors.purple_3};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  ${ConversationItemActions} {
    opacity: 1;
  }
`;
const HoverStyle = css `
  background: ${({ theme }) => theme.colors.beige_4};
  border-color: ${({ theme }) => theme.colors.grey_4};
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};

  ${ConversationItemActions} {
    opacity: 1;
  }
`;
export const ConversationItemContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  border-width: 1px 1px 1px ${({ theme }) => theme.spacing.xs}px;
  border-style: solid;
  border-color: transparent;
  align-items: flex-start;
  padding-inline: ${({ theme }) => theme.spacing.md}px;
  padding-block: ${({ theme }) => theme.spacing.sm}px;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  transition: all 0.2s ease;

  ${ConversationItemActions} {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  ${({ $isActive }) => $isActive
    ? ActiveStyle
    : css `
          &:hover {
            ${HoverStyle}
          }
        `}
`;
export const AssistantConversationsListInline = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
`;
